<template>
  <div>
    <header class="appHeader" :class="{lib:isLibrary}">
      <ul class="headerNav" >
        <li>
          <a href="https://agaru.tv" >
          <img src="/static/img/store-logo.svg" width="120" height="17" alt="AGARUTV">
          </a>
        </li>
        <li>
          <a href="https://agaru.tv/">
            <img
              :src="`/static/img/ic-home-gr-on.svg`"
              width="20" height="20">
            <span>ホーム</span>
            </a>
        </li>
        <li>
          <a href="https://agaru.tv/linear" >
            <img :src="`/static/img/ic-live-tv-gr-on.svg`" width="20" height="20">
            <span>テレビ</span>
            </a>
        </li>
        <li>
          <a href="https://agaru.tv/movie">
            <img :src="`/static/img/ic-archives-gr-on.svg`" width="20" height="20">
            <span>オンデマンド</span>
            </a>
        </li>
        <li>
          <a href="https://agaru.tv/timetable/">
            <img
              :src="`/static/img/ic-calendar-gr-on.svg`"
              width="20" height="20">
            <span>番組表</span>
            </a>
        </li>
        <li class="headerNav__bar">
          <a href="/">
            <img
              :src="`/static/img/ic-store-gr-on.svg`"
              width="20" height="20">
            <span>ストア</span>
            </a>
        </li>

        <li class="headerNavAccount">
          <span class="head-user-point" v-if="userPoints != ''">
            <img src="/static/img/coin_icon.svg"><span class="pt">{{ userPoints | priceFormat }}pt</span>
          </span>
          <a @click="showOtherNav">
            <span>購入アカウント</span>
          </a>
        </li>
        <li class="headerNavOther" v-if="isShowNavOther" @click="disableCloseNav">
          <ul class="headerNavOther__list" v-if="isLoggedIn">
            <li class="headerNavOther__listItem">
              <a href="/user/account" target="">登録情報</a>
            </li>
            <li class="headerNavOther__listItem">
              <a href="/payment/library">購入履歴
              </a>
            </li>
            <li class="headerNavOther__listItem">
              <a href="/user/logout" >ログアウト
              </a>
            </li>
          </ul>
          <ul class="headerNavOther__list" v-if="!isLoggedIn">
            <li class="headerNavOther__listItem">
              <a :href="`/user/login?show=signup?return_path=${location}`" >会員登録</a>
            </li>
            <li class="headerNavOther__listItem">
              <a  :href="`/user/login?show=signin?return_path=${location}`" >ログイン </a>
            </li>
          </ul>
        </li>
      </ul>
      <div class="appHeader__row appHeader__menue" v-if="!headerLayout">
        <div class="appHeader__control" @click="toggleMenu">
          <img src="/static/img/ic-menu.svg" />
        </div>
        <div class="appHeader__brand">
          <a href="https://agaru.tv">
            <img
              :src="brandImage.src"
              :width="brandImage.width"
              :height="brandImage.height"
              alt="AGARUTV"
            >
          </a>
        </div>
        <div class="head-user-point head-user-point-sp" v-if="userPoints != ''">
          <img src="/static/img/coin_icon.svg"><span class="pt">{{ userPoints | priceFormat }}pt</span>
        </div>
      </div>

      <!--ライブラリ-->
      <div class="appHeader__row" v-else-if="headerLayout === 'library'">
        <div class="appHeader__control">
          <!-- blank -->
        </div>
        <div class="appHeader__control"></div>
        <div class="appHeader__brand">
          <span>購入履歴</span>
        </div>
        <div class="appHeader__control"></div>

        <a href="/" class="appHeader__control">
          <i class="material-icons">close</i>
        </a>
      </div>

      <!--fes-->
      <div class="appHeader__row" v-else-if="headerLayout === 'fes'">
        <div class="appHeader__control">
          <img src="/static/img/ic-menu.svg" />
        </div>
        <div class="appHeader__control"></div>
        <div class="appHeader__brand">
          <a href="https://uranaifes.com/" target="_brank">
            <img
              :src="brandImage.src"
              :width="brandImage.width"
              :height="brandImage.height"
              alt="AGARUTV"
            >
          </a>
        </div>
      </div>
    </header>

    <information-shop
      :showAdArea="showAdArea"
      :strMsg="'AGARUTVで紹介した商品や、出演する占い師の占いを体験できるオリジナルショップです！'"
    ></information-shop>

    <div class="adbanner_area" v-if="showAdArea">
      <information-message
        v-if="preRegist"
        class="adbanner_area__item"
        str-msg="メールアドレスの認証をお願いします"
        href-url="/user/account/mail/reauth"
      ></information-message>

      <top-daily-fortune :aws-prefix="awsPrefix"></top-daily-fortune>

      <!--　セールバナー -->
      <!--<div class="adbanner_area__item">
        <a href="/lp/movie/licorice?top_banner=1" class="link">
          <img class="image" src="/static/img/ad/ad_licorice_aftercampaign.jpg">
          <img class="image" src="/static/img/ad/ad_licorice.jpg"> -->
          <!-- <img class="image" src="/static/img/ad/ad_licorice_free.jpg">
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { UPDATE_MENU_VISIBILITY, UPDATE_SEARCH_VISIBILITY } from '@/utvStore/store/mutation-types';
const showAdArray = ['/'];
export default {
  name: 'appHeader',
  data() {
    return {
      isShowNavOther: false,
      brandImage: {
        src: '/static/img/store-logo.svg',
        width: '120',
        height: '17'
      },
      isLibrary: false,
      showAdArea: false
    };
  },
  props: {
    userPoints: String,
    headerLayout: String,
    preRegist: Boolean,
    awsPrefix: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      showMenu: state => state.uiState.showMenu,
      showSearch: state => state.uiState.showSearch
    }),
    ...mapGetters(['isLoggedIn'])
  },
  beforeMount() {
    this.showAdArea = showAdArray.indexOf(window.location.pathname) < 0 ? false : true;
  },
  mounted() {
    // 初期状態はメニューなどは開いていない状態
    this.$store.dispatch(UPDATE_MENU_VISIBILITY, false);
    this.$store.dispatch(UPDATE_SEARCH_VISIBILITY, false);
    this.isLibrary = this.headerLayout === 'library' ? true : false;
    this.setCloseEvent();
  },
  watch: {
    showMenu: state => {
      $('html, body').css({
        overflowY: state ? 'hidden' : 'auto'
      });
    },
    lastName: function(val) {
      this.fullName = this.firstName + ' ' + val;
    }
  },
  methods: {
    toggleMenu() {
      this.$store.dispatch(UPDATE_MENU_VISIBILITY, !this.showMenu);
    },
    toggleSearch() {
      this.$store.dispatch(UPDATE_SEARCH_VISIBILITY, !this.showSeaerch);
    },
    toggleDownloads() {},
    historyBack() {
      window.history.back();
    },
    isIn(_start = '', _end = '') {
      const start = moment(_start);
      const end = moment(_end);
      if (!start.isValid() || !end.isValid()) {
        console.warn('日時の指定が正しくありません');
        return false;
      }
      return moment().isBetween(_start, _end);
    },
    showOtherNav(e) {
      e.preventDefault();
      e.stopPropagation();
      this.isShowNavOther = !this.isShowNavOther;
    },
    disableCloseNav(e) {
      e.stopPropagation();
    },
    setCloseEvent() {
      window.addEventListener('click', () => {
        if (this.isShowNavOther) {
          this.isShowNavOther = false;
        }
      });
    },
  },
  filters: {
    priceFormat(val) {
      return Number(val).toLocaleString()
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../sass/variables/layout.scss";
@import "../../../sass/variables/colors.scss";
@import "../../../sass/variables/index";

$color-agaru-navy: #1b1464;
.headerNav {
  list-style: none;
//  padding: 16px 0 16px 0;
  padding:  0;
  margin: 0;
  display: flex;
  position: relative;
  height: 52px;
  visibility: visible;
  pointer-events: auto;
  @media screen and (max-width: $breakpoint) {
    visibility: hidden;
    pointer-events: none;
    padding: 0;
    height: 0;
    }
  &__bar {
    border-bottom: 4px solid #1B1464;
//    margin-bottom: auto;
 //   padding-bottom: 8px;
  }
  > li {
    display: flex;
    > a {
      align-items: center;
      cursor: pointer;
      display: flex;
      font-size: 15px;
      font-weight: bold;
      padding: 0 12px;
      position: relative;
      text-decoration: none;
      &.active {
        color: $color-agaru-navy;
        &::after {
          background: $color-agaru-navy;
          bottom: 0;
          content: '';
          height: 4px;
          left: 0;
          position: absolute;
          width: 100%;
        }
      }
      > img {
        margin-right: .5em;
      }
    }
  }
}

.headerNavAccount{
  margin-left: auto;
  margin-right: 15px;

}
.headerNavOther {
  position: absolute;
  background: #f8f8f8;
  padding: 24px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 6px 0 rgba(0,0,0,.1);
  border: solid 1px #efefef;
  right: 15px;
  top: 60px;
  z-index: 10;

  &__list {
    list-style: none;
    padding: 0;
  }

  &__listItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 2;

    &:not(:first-child) {
      margin-top: 2px;
    }

    > img {
      margin-top: 2px;
      margin-left: 10px;
    }

    > a {
      font-size: 14px;
      color: #4a4a4a;
      font-weight: bold;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  &__listSection {
    padding-top: 16px;
    border-top: 1px solid #d8d8d8;
    &:not(:first-child) {
      margin-top: 16px;
    }
  }
}
.head-user-point {
  color: $brand-2;
  display: flex;
  align-items: center;
  line-height: 20px;
  text-align: right;
  img{
    display: inline-block;
    margin-right: 5px;
    width: 17px;
    @include mq('w320'){
      width: 17px;
    }
    @include mq () {
      width: 23px;
    }
  }
  .pt {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    @include mq('w320'){
      font-size: 16px;
    }
    @include mq () {
      font-size: 16px;
    }
  }
}
.head-user-point-sp {
  position: absolute;
  right: 8px;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/AppHeader.vue